import axios from 'axios';

import store from '@/app/shared/state';
import { STATUS } from '@/app/shared/state/asyncState';

import Constants from '@/common/constants';
import runtimeConfig from '@/common/runtime-config';

export default {
  downloadFile(url, filename, params) {
    var options = { responseType: 'blob' };
    if (params) {
      options.params = params;
    }
    return axios
      .get(url, options)
      .then((response) => {
        this.downloadFileResponse(response, filename);
      })
      .catch((error) => {
        if (!this.notifyIfDownloadUnauthorized()) throw error;
      });
  },
  notifyIfDownloadUnauthorized() {
    if (!store.getters['auth/oidc/isAuthenticated']) {
      Constants.alert.fire(Constants.authErrorTitle, Constants.authErrorSubtitle, 'error');
      return true;
    }
    return false;
  },
  downloadFileResponse(response, filename) {
    const blob = new Blob([response.data], { type: response.data.type });
    const link = document.createElement('a');
    const contentDisposition = response.headers['content-disposition'];
    filename = filename || 'download';
    if (contentDisposition) {
      const matches = contentDisposition.match(/filename=([\w\d\-_.]+)/);
      if (matches?.length === 2) {
        filename = matches[1];
      }
    }
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
  },
  loadSelectOptions(dictName, optionsArray, requestData, isClear) {
    this.searchNsi(dictName, requestData).then(function (response) {
      if (isClear) {
        while (optionsArray.length > 1) optionsArray.pop();
      }

      if (response.data && response.data.length) {
        response.data.forEach((i) => optionsArray.push(i));
      }
    });
  },
  searchNsi(dictName, requestData) {
    return axios.get('/api/nsi/' + dictName, { params: requestData });
  },
  groupList(list, keyGetter, itemGetter) {
    let result = [];
    list.forEach((item) => {
      const key = keyGetter(item);
      let group = result.find((x) => x.id === key.id);
      if (!group) {
        group = { id: key.id, text: key.text, children: [] };
        result.push(group);
      }
      let child;
      if (typeof itemGetter === 'function') {
        child = itemGetter(item);
      } else {
        child = { id: item.id, text: item.name };
      }
      group.children.push(child);
    });
    return result;
  },
  getFileUrl(id) {
    const baseUrl = runtimeConfig.apiBaseUrl;
    return `${baseUrl}/api/file/downloadguid?guid=${id}`;
  },
  isObjectHasValue(object) {
    if (object.constructor !== Object) {
      throw new TypeError('Переданное значене не является объектом');
    }

    for (const key in object) {
      // eslint-disable-next-line no-prototype-builtins
      if (object.hasOwnProperty(key) && object[key]) {
        return true;
      }
    }

    return false;
  },
  getPreparedMobilePhone(phoneNumber) {
    if (!phoneNumber) return;
    return String(phoneNumber).replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, '+$1 $2 $3-$4-$5');
  },
};
export const findItemNested = (arr, itemId, nestingKey) =>
  arr.reduce((a, item) => {
    if (a) return a;
    if (item.id == itemId) return item;
    if (item[nestingKey]) return findItemNested(item[nestingKey], itemId, nestingKey);
  }, null);

const isPathInMenu = (path, menuItems) => {
  for (const item of menuItems) {
    if (item.link === path) return true;
    if (item.link && path.startsWith(item.link + '/')) return true;
    if (item.link && path.startsWith(item.link + '?')) return true;
    if (item.submenu && isPathInMenu(path, item.submenu)) return true;
  }
  return false;
};

export const checkMenuGuard = async (to, from, next) => {
  if (store.state.menu.status === STATUS.IDLE || store.state.menu.status === STATUS.ERROR) {
    await store.dispatch('getMenu');
  } else if (store.state.menu.status === STATUS.LOADING) {
    await new Promise((resolve) => {
      const unwatch = store.watch(
        (state) => state.menu.status,
        (newStatus) => {
          if (newStatus === STATUS.SUCCESS || newStatus === STATUS.ERROR) {
            unwatch();
            resolve();
          }
        },
      );
    });
  }

  const menuItems = store.state.menu.data;
  const found = isPathInMenu(to.path, menuItems);
  if (found) {
    next();
  } else {
    next({ name: 'NotFound' });
  }
};
